import { Currency } from "@redotech/money/currencies";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import {
  InsertionPosition,
  SlideInPanelAnchorLocation,
} from "./widget-types";

interface CommonLoyaltyInfo {
  pointsForPurchase: number;
}

export type LoggedOutLoyaltyInfo = CommonLoyaltyInfo & { loggedIn: false };

export type LoggedInLoyaltyInfo = CommonLoyaltyInfo & {
  loggedIn: true;
  customerId: string;
  customerName: string | undefined;
  pointsBalance: number;
  singlePointValue: { currency: Currency; amount: number };
  loyaltyDashboardUrl?: string | undefined;
};

export type LoyaltyInfo = LoggedOutLoyaltyInfo | LoggedInLoyaltyInfo;

/**
 * Main schema for loyalty storefront popup settings
 */
const storefrontPopupSchema_ = z.object({
  enabled: z.boolean(),
  anchorPosition: createEnum(SlideInPanelAnchorLocation, {
    enumName: "SlideInPanelAnchorLocation",
  }),
});

export const storefrontPopupSchema: z.ZodType<StorefrontPopup> =
  storefrontPopupSchema_;

export type StorefrontPopup = z.infer<typeof storefrontPopupSchema_>;

const storefrontEmbeddingSchema_ = z.object({
  enabled: z.boolean(),
  selector: z.string(),
  insertPosition: createEnum(InsertionPosition, {
    enumName: "InsertionPosition",
  }),
});

export const storefrontEmbeddingSchema: z.ZodType<StorefrontEmbedding> =
  storefrontEmbeddingSchema_;

export type StorefrontEmbedding = z.infer<typeof storefrontEmbeddingSchema_>;
